import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const AmbassadorsListComponent = React.lazy(() => import('./components/AmbassadorsList'));

const AmbassadorsList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <AmbassadorsListComponent />
      </Suspense>
    </div>
  );
};

export default AmbassadorsList;
